<template>
  <div class="table-responsive" ref="scroll" @wheel.passive="autoScroll">
    <div class="with-print">
      <p class="table-head">운전자별 운행내역</p>
      <div class="col" v-if="printBtn == 'on'">
        <button class="btn btn-secondary" @click="$emit('printFn')">
          <BIconPrinter/>&nbsp;인쇄
        </button>
      </div>
    </div>
    <table class="table table-sm" ref="table">
      <colgroup>
        <col class="bg-soft-primary">
        <col>
        <col class="bg-soft-primary">
        <col>
        <col class="bg-soft-primary">
        <col>
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">{{fields[10].label}}</th>
          <td>{{elements.carNum}}</td>
          <th scope="row">{{fields[11].label}}</th>
          <td>{{elements.driverId}}</td>
          <th scope="row">{{fields[7].label}}</th>
          <td>{{elements.allWorkCount ? insertComma(elements.allWorkCount) : 0 }}회</td>
        </tr>
      </tbody>
    </table>

    <table class="table table-sm" ref="table">
      <colgroup>
        <col class="bg-soft-primary">
        <col>
        <col class="bg-soft-primary">
        <col>
        <col class="bg-soft-primary">
        <col>
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">{{fields[3].label}}</th>
          <td>{{elements.allWorkDist}}km</td>
          <th scope="row">{{fields[4].label}}</th>
          <td>{{elements.allBlankDist}}km</td>
          <th scope="row">{{fields[12].label}}</th>
          <td>{{elements.allDist}}km</td>
        </tr>
        <tr>
          <th scope="row">{{fields[5].label}}</th>
          <td>{{elements.allWorkTime}}</td>
          <th scope="row">{{fields[6].label}}</th>
          <td>{{elements.allBlankTime}}</td>
          <th scope="row">{{fields[13].label}}</th>
          <td>{{elements.allTime}}</td>
        </tr>
      </tbody>
    </table>

    <p class="table-head">결제타입별 영업내역</p>
    <table class="table table-sm horizon" ref="table">
      <tbody>
        <tr>
          <th scope="row">{{typeList[0]}}</th>
          <th scope="row">{{typeList[9]}}</th>
          <th scope="row">{{typeList[5]}}</th>
          <th scope="row">{{typeList[11]}}</th>
          <th scope="row">기타</th>
          <th scope="row">{{fields[0].label}}</th>
        </tr>
        <tr class="text-right">
          <td>{{ elements.summaryPay ? elements.summaryPay["0"] ? insertComma(elements.summaryPay["0"]) : 0 : 0}}원</td>
          <td>{{ elements.summaryPay ? elements.summaryPay["9"] ? insertComma(elements.summaryPay["9"]) : 0 : 0}}원</td>
          <td>{{ elements.summaryPay ? elements.summaryPay["5"] ? insertComma(elements.summaryPay["5"]) : 0 : 0}}원</td>
          <td>{{ elements.summaryPay ? elements.summaryPay["11"] ? insertComma(elements.summaryPay["11"]) : 0 : 0}}원</td>
          <td>{{ elements.summaryPay ? elements.summaryPay["98"] ? insertComma(elements.summaryPay["98"]) : 0 : 0}}원</td>
          <td>{{elements.summaryPay ? elements.summaryPay["100"] ? insertComma(elements.summaryPay["100"]) : 0 : 0}}원</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import {ref, defineEmits, defineProps} from "vue";
import tachoEntity from "@/entity/TachoEntity";
import { insertComma } from "@/components/tacho/common/CommonFunc";
import {BIconPrinter} from "bootstrap-icons-vue"
  const props = defineProps({
    fields: Object,
    elements: Object,
    selectAutoScroll: Function,
    onSelected: Function,
    onDoubleClick: Function,
    printBtn: String
  });
  const scroll = ref("");
  const typeList = tachoEntity.paymentTypeEnum;

  const autoScroll = () => (props.selectAutoScroll !== undefined && scroll.value.scrollHeight - scroll.value.scrollTop <= scroll.value.clientHeight) ? props.selectAutoScroll() : "";

  //const emit = defineEmits(['printFn'])

</script>

<style scoped>
* {
  font-size: 0.8rem;
}
th {
  background-color: #e3e3e3 !important;
  border-color: #c9c8c8 !important;
  width: 8rem;
  font-weight: 500;
  border-top: 1px solid #c9c8c8;
  border-bottom: 1px solid #c9c8c8;
}
td {
  width: 10rem;
  border-top: 1px solid #c9c8c8;
  /* border-bottom: 1px solid #c9c8c8; */
}
.last-tr {
  border-bottom: 1px solid #c9c8c8;
}
p.table-head {
  margin-bottom: 0.3rem;
  font-size: 0.8rem;
  font-weight: 600;
}

div.with-print {
  position:relative;
  height:2rem;
  margin-bottom: 0.3rem;
}
div.with-print>p {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: 0 !important;
}
div.with-print>div {
  position: absolute;
  bottom: 0;
  right: 0;
}

</style>